window.addEventListener('DOMContentLoaded', function () {
  /* ============================================
   * Form - Focus First Item and basic validation
   * ============================================ */
  (function () {
    const inputs = document.querySelectorAll('.form__input, .form__select')

    // Focus
    if (inputs.length > 0) {
      inputs[0].focus()
    }

    // Dirty
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('blur', function (ev) {
        this.classList.add('dirty')
      })
    }
  })()
})
